import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Avatar, Badge, Box, Button, Form, IconButton, Stack, Text, TextInput } from 'shell/components';

const MobileEditProfile = ({
    loading,
    form,
    isDirty,
    errors,
    onChange,
    onSubmit,
    onCancel,
    onClickEditProfileImage,
    setSelected,
}) => {
    const { t } = useTranslation();

    return (
        <Stack spacing={4}>
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <IconButton
                    aria-label={'back'}
                    kind={'arrowLeft'}
                    size={'medium'}
                    variant={'square'}
                    onClick={() => setSelected('')}
                />
                <Text component={'h1'} size={'small'} variant={'h6'} weight={'semibold'}>
                    {t('account-settings.profile.title', 'Edit Profile')}
                </Text>
            </Stack>
            <Box>
                <Badge
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                        <CustomIconButton
                            aria-label={'change avatar'}
                            kind={'edit'}
                            size={'small'}
                            variant={'circle'}
                            onClick={onClickEditProfileImage}
                        />
                    }
                    overlap={'circular'}
                >
                    <Avatar size={'x-large'} user={form} />
                </Badge>
            </Box>
            <Form onSubmit={onSubmit}>
                <Stack spacing={4}>
                    <TextInput
                        error={Boolean(errors.first_name)}
                        helperText={errors.first_name}
                        label={t('account-settings.profile.first-name', 'First Name')}
                        required
                        value={form.first_name}
                        onChange={(e) => onChange('first_name', e.target.value)}
                    />
                    <TextInput
                        error={Boolean(errors.last_name)}
                        helperText={errors.last_name}
                        label={t('account-settings.profile.last-name', 'Last Name')}
                        required
                        value={form.last_name}
                        onChange={(e) => onChange('last_name', e.target.value)}
                    />
                    <TextInput
                        label={t('account-settings.profile.preferred-name', 'Preferred Name')}
                        value={form.display_name}
                        onChange={(e) => onChange('display_name', e.target.value)}
                    />
                    <TextInput
                        disabled={true}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        label={t('account-settings.profile.email', 'Email')}
                        required
                        value={form.email}
                        onChange={(e) => onChange('email', e.target.value)}
                    />
                    <ButtonStack direction={'row-reverse'} spacing={2}>
                        <Button disabled={!isDirty} loading={loading} type={'submit'}>
                            {t('controls.save', 'Save')}
                        </Button>
                        {isDirty && (
                            <Button disabled={loading} variant={'secondary'} onClick={onCancel}>
                                {t('controls.cancel', 'Cancel')}
                            </Button>
                        )}
                    </ButtonStack>
                </Stack>
            </Form>
        </Stack>
    );
};

const CustomIconButton = styled(IconButton)(({ theme }) => {
    return {
        border: `3px solid ${theme.palette.ensightful.shades[0]}`,
    };
});

const ButtonStack = styled(Stack)(() => {
    return {
        alignSelf: 'flex-end',
    };
});

export default MobileEditProfile;
